import type { ApiEntity } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  apiDocsConfigRef,
  defaultDefinitionWidgets,
} from '@backstage/plugin-api-docs';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import { createElement } from 'react';
import { DataContractWidget } from './DataContractWidget';

const definitionWidgets = defaultDefinitionWidgets();

const apiDocsConfig = apiDocsPlugin
  .getExtension('api:api-docs/config')
  .override({
    // Must use top-level `params` — wrapping via factory(originalFactory)({ params })
    // does not replace the ApiBlueprint factory, so datacontract falls back to raw YAML.
    params: defineParams =>
      defineParams({
        api: apiDocsConfigRef,
        deps: {},
        factory: () => ({
          getApiDefinitionWidget: (apiEntity: ApiEntity) => {
            if (apiEntity.spec.type === 'datacontract') {
              return {
                type: 'datacontract',
                title: 'DataContract',
                rawLanguage: 'yaml',
                component: (definition: string) =>
                  createElement(DataContractWidget, { definition }),
              };
            }

            return definitionWidgets.find(d => d.type === apiEntity.spec.type);
          },
        }),
      }),
  });

export const datacontractModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [apiDocsConfig],
});
